// 新聞頁面 - 互動功能列

import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { newsState, setNewsSocialCount } from '@/slices/newsSlice';
import newsClient from '@/common/apiClient/newsClient';

import NewsEmoji from './NewsEmoji'; // 按讚表情符號
import NewsCollectButton from './NewsCollectButton'; // 收藏
import NewsEmojiDisplay from './NewsEmojiDisplay'; // 表情符號紀錄顯示
import NewsShare from './NewsShare'; // 新聞社群分享
import NewsBottomFunction from './NewsBottomFunction'; // 手機版置底功能列

const NewsInteractionFunction = ({ t, emojis = [], newsId, targetRef }) => {
    const dispatch = useDispatch();
    const { newsSocialCount } = useSelector(newsState);

    // 讚 + 表情符號
    const [thumbedEmojis, setThumbedEmojis] = useState(emojis);

    // 跳到表情符號顯示
    const handleJumpToEmoji = () => {
        const target = document.querySelector('#emoji-target');
        if (target) target.scrollIntoView({ block: 'center' });
    };

    // 點擊表情符號
    const onClickEmoji = async (emojiId) => {
        const emojiData = thumbedEmojis.find((v) => v.id === emojiId);

        const { count, isThumbed } = emojiData;

        try {
            const result = await newsClient.postNewsEmoji(newsId, emojiId);

            if (result.message === 'success') {
                // 判斷是否取消
                setThumbedEmojis((prev) => {
                    return (prev ?? []).map((v) =>
                        v.id === emojiId
                            ? {
                                  ...v,
                                  isThumbed: !isThumbed,
                                  count: count + (isThumbed ? -1 : 1),
                              }
                            : v
                    );
                });
                // 跳到表情符號顯示
                if (!isThumbed) handleJumpToEmoji();
            }
        } catch (e) {
            console.error(e);
        }
    };

    // 按讚
    const onThumb = async () => {
        // 按讚紀錄
        const thumbData = thumbedEmojis.find((v) => v.id === 'thumb');
        const { count, isThumbed } = thumbData;

        try {
            const result = await newsClient.postNewsThumb(newsId);

            if (result.message === 'success') {
                // 判斷是否取消
                setThumbedEmojis((prev) => {
                    return (prev ?? []).map((v) =>
                        v.id === 'thumb'
                            ? {
                                  ...v,
                                  isThumbed: !isThumbed,
                                  count: count + (isThumbed ? -1 : 1),
                              }
                            : v
                    );
                });
                dispatch(
                    setNewsSocialCount({
                        thumb: newsSocialCount?.thumb + (isThumbed ? -1 : 1),
                    })
                );
                // 跳到表情符號顯示
                if (!isThumbed) handleJumpToEmoji();
            }
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <>
            {/* 表情符號紀錄顯示 (有按過的才會顯示) */}
            <NewsEmojiDisplay
                onThumb={onThumb}
                emojis={thumbedEmojis}
                onClickEmoji={onClickEmoji}
            />

            <div
                className="py-[30px] border-t-1 border-b-1 border-dashed border-black6 border-opacity-[.5]
                    gap-x-[35px] between-center [&>*]:relative [&>*]:z-0 ulg:hidden"
                ref={targetRef}
            >
                {/* 按讚表情符號 */}
                <NewsEmoji
                    t={t}
                    emojis={emojis}
                    newsId={newsId}
                    onThumb={onThumb}
                    onClickEmoji={onClickEmoji}
                />

                <span className="w-[1px] h-[10px] border-l-1 border-black2" />

                {/* 收藏 */}
                <NewsCollectButton newsId={newsId} />

                <span className="w-[1px] h-[10px] border-l-1 border-black2" />

                {/* 分享 */}
                <NewsShare newsId={newsId} />
            </div>

            {/* 手機版置底功能列 */}
            <NewsBottomFunction newsId={newsId} emojis={emojis} onClickEmoji={onClickEmoji} />
        </>
    );
};

export default NewsInteractionFunction;
